import { Component } from '@angular/core';

/**
 * Account users.
 */
@Component({
  templateUrl: './user-list.component.html',
})
export class UserListComponent {}
